import React, { useEffect, useState, useRef } from "react";
import { connect } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import FormGroup from "@material-ui/core/FormGroup";
import PromotionalCamp from "../../Tables/promotionalCamp";
import moment from "moment";
import {
  Grid,
  Typography,
  InputLabel,
  TextField,
  Divider,
  FormControl,
  MenuItem,
  FormControlLabel,
  Radio,
  Checkbox,
  Button,
  RadioGroup,
} from "@material-ui/core";
import {
  getCenterInfo,
  getPackage,
  createPromoCamp,
} from "../../actions/GenomicsAdminAction";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { useHistory } from "react-router-dom";
const useStyles = makeStyles((theme) => ({
  root: {
    width: "90%",
    margin: "0px auto",
  },
  tcolor: {
    color: "black",
    fontWeight: "bolder",
  },

  row: {
    color: "black",
    fontSize: "larger",
    fontWeight: "bolder",
  },
  margin: {
    margin: theme.spacing(1),
  },
}));

interface Props {
  getPackage: any;
  packageList: any;
  createPromoCamp: any;

  getCenterInfo: any;
  centerInfo: any;
}

const PromotionalCampMaster: React.FC<Props> = ({
  packageList,
  getPackage,
  createPromoCamp,
  getCenterInfo,
  centerInfo,
}) => {
  const classes = useStyles();
  const history = useHistory();
  const [centreId, setCentreId] = useState<any>("");
  const [centreIdFilt, setCentreIdFilt] = useState<any>("");
  const [centreIdProp, setCentreIdProp] = useState<any>("");
  const [discountName, setDiscountName] = useState<any>("");
  const [discountPercentage, setDiscountPercentage] = useState<any>("");
  const [validFrom, setVadilFrom] = useState<any>("");
  const [validTo, setValidTo] = useState<any>("");
  const [ageFrom, setAgeFrom] = useState<any>("");
  const [ageTo, setAgeTo] = useState<any>("");
  const [gender, setGender] = useState<any>("both");
  const [campCostsTo, setcampCostsTo] = useState<any>("");
  const [isActive, setIsActive] = useState<any>(true);
  const [isActiveFilt, setIsActiveFilt] = useState<any>(true);
  const [isActiveProp, setIsActiveProp] = useState<any>(true);
  const [open, setOpen] = React.useState(false);
  const [packageId, setPackageId] = useState<any>([]);
  useEffect(() => {
    getCenterInfo();
  }, []);
  useEffect(() => {
    if (centreId !== "") {
      getPackage(centreId, "");
    }
  }, [centreId]);
  const timer = useRef<any>(0);

  const submitAgeWiseDiscount = async (e: any) => {
    e.preventDefault();
    const data: any = {
      discount_type: "percentage",
      coupon_type: "camp",
      gender: gender,
      name: discountName,
      code: discountName,
      discount: discountPercentage,
      center: centreId,
      valid_from: validFrom,
      valid_till: validTo,
      from_age: Number(ageFrom),
      to_age: Number(ageTo),
      is_active: isActive,
      camp_costs_to: campCostsTo,
      packages: packageId,
    };

    await createPromoCamp(data);
    history.push("/dashboard/gnadmin/promotional_campaign");
  };
  const handleFilter = () => {
    setIsActiveProp(isActiveFilt);
    setCentreIdProp(centreIdFilt);
  };

  return (
    <div>
      <form
        onSubmit={submitAgeWiseDiscount}
        autoComplete="off"
        style={{ width: "100%", marginTop: 50 }}
      >
        <Grid container>
          <Grid container item xs={12}>
            <Typography variant="h4" component="h1" gutterBottom>
              <b>Promotional Campaign</b>
            </Typography>
          </Grid>

          {/*Grid 1 */}

          <Grid container spacing={3}>
            <Grid item xs={12} sm={4} md={2}>
              <TextField
                required
                variant="outlined"
                label="Discount Name"
                fullWidth
                value={discountName}
                onChange={(e) => setDiscountName(e.target.value)}
              />
            </Grid>
            <Grid item xs={12} sm={4} md={2}>
              <TextField
                required
                fullWidth
                value={discountPercentage}
                variant="outlined"
                type="number"
                label="Discount Percentage"
                onChange={(e) => setDiscountPercentage(e.target.value)}
              />
            </Grid>
            <Grid item xs={12} sm={4} md={3}>
              <TextField
                required
                type="datetime-local"
                fullWidth
                variant="outlined"
                label="Valid From"
                InputLabelProps={{
                  shrink: true,
                }}
                inputProps={{
                  min: moment().format("YYYY-MM-DDTHH:MM"),
                }}
                value={validFrom}
                onChange={(e) => setVadilFrom(e.target.value)}
              />
            </Grid>

            <Grid item xs={12} sm={4} md={3}>
              <TextField
                required
                type="datetime-local"
                fullWidth
                variant="outlined"
                label="Valid To"
                inputProps={{
                  min: moment().format("YYYY-MM-DDTHH:MM"),
                }}
                helperText={
                  moment(validTo).isAfter(validFrom) || validFrom === ""
                    ? ""
                    : "Valid To Should Greater Than Valid From"
                }
                InputLabelProps={{
                  shrink: true,
                }}
                value={validTo}
                onChange={(e) => setValidTo(e.target.value)}
              />
            </Grid>
            <Grid item xs={12} sm={4} md={2}>
              <TextField
                required
                type="number"
                label="Camp Cost To"
                variant="outlined"
                select
                fullWidth
                value={campCostsTo}
                onChange={(e) => setcampCostsTo(e.target.value)}
              >
                <MenuItem value="center">Center</MenuItem>
                <MenuItem value="redcliffe">Redcliffe</MenuItem>
                <MenuItem value="both">Both</MenuItem>
              </TextField>
            </Grid>
            <Grid item xs={12} sm={4} md={2}>
              <TextField
                required
                type="number"
                label="Age From (in Years)"
                variant="outlined"
                fullWidth
                value={ageFrom}
                onChange={(e) => setAgeFrom(e.target.value)}
              />
            </Grid>

            <Grid item xs={12} sm={4} md={2}>
              <TextField
                required
                type="number"
                label="Age To (in Years)"
                id="employee-id"
                variant="outlined"
                disabled={ageFrom === ""}
                fullWidth
                helperText={
                  ageFrom !== ""
                    ? ageTo > ageFrom
                      ? ""
                      : "Age To Should greater Than Age From"
                    : ""
                }
                value={ageTo}
                onChange={(e) => setAgeTo(e.target.value)}
              />
            </Grid>

            <Grid item xs={12} sm={4} md={4}>
              <Autocomplete
                id="center"
                onChange={(event, newValue) => {
                  if (newValue) {
                    let obj = JSON.parse(JSON.stringify(newValue, null, " "));
                    setCentreId(obj.id);
                  }
                }}
                freeSolo
                blurOnSelect
                options={centerInfo?.results}
                disableCloseOnSelect
                getOptionLabel={(option: any) =>
                  (option?.display_name === null
                    ? option?.name
                    : option?.display_name) +
                  "(" +
                  option?.center_code +
                  ")"
                }
                onInputChange={(event, newInputValue) => {
                  getCenterInfo(`?name_or_code=${newInputValue}`);
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Hospital/Doctor"
                    variant="outlined"
                    fullWidth
                    required
                  />
                )}
              />
            </Grid>

            <Grid item xs={12} sm={4} md={4}>
              <Autocomplete
                id="customerPackage"
                onChange={(event, newValue) => {
                  if (newValue) {
                    let packs: any = [];
                    newValue.map((val: any) => {
                      let obj = JSON.parse(JSON.stringify(val, null, " "));
                      packs.push(obj.id);
                    });
                    setPackageId(packs);
                  }
                }}
                limitTags={0}
                options={packageList?.results || []}
                freeSolo
                multiple
                disableCloseOnSelect
                disabled={centreId === "" || packageList.results === undefined}
                aria-required
                onInputChange={(event, newInputValue) => {
                  setTimeout(getPackage(centreId, newInputValue), 1000);
                }}
                getOptionLabel={(option: any) => {
                  return option.name && option.package_city_prices
                    ? option.name.toString() +
                        ", " +
                        option.package_city_prices.tat_time
                    : option.name + ", " + option.tat_time;
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder="Tests"
                    variant="outlined"
                    fullWidth
                  />
                )}
              />
            </Grid>

            <Grid item xs={12} sm={4} md={1}>
              <InputLabel
                htmlFor="gender"
                style={{
                  marginTop: "13px",
                  fontWeight: "bold",
                  color: "Black",
                  fontSize: "larger",
                }}
              >
                Gender
              </InputLabel>
            </Grid>

            <Grid item xs={12} sm={4} md={4}>
              <FormControl component="fieldset">
                <RadioGroup
                  row
                  aria-label="gender"
                  name="gender"
                  value={gender}
                  onChange={(e) => setGender(e.target.value)}
                >
                  <FormControlLabel
                    value="female"
                    control={<Radio />}
                    label="Female"
                  />
                  <FormControlLabel
                    value="male"
                    control={<Radio />}
                    label="Male"
                  />
                  <FormControlLabel
                    value="both"
                    control={<Radio />}
                    label="Both"
                  />
                </RadioGroup>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={4} md={2}>
              <FormControl component="fieldset">
                <FormGroup aria-label="position" row>
                  <FormControlLabel
                    control={
                      <Checkbox
                        color="primary"
                        checked={isActive}
                        onClick={() => {
                          setIsActive(!isActive);
                        }}
                      />
                    }
                    label="Is Active"
                    labelPlacement="end"
                  />
                </FormGroup>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={4} md={3}>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                size="large"
                disabled={
                  !moment(validTo).isAfter(validFrom) || ageTo < ageFrom
                }
                fullWidth
              >
                Submit
              </Button>
            </Grid>
          </Grid>

          <Grid item xs={12}>
            <Divider style={{ margin: "15px 0px" }} />
          </Grid>
        </Grid>
      </form>
      <Grid container spacing={3} style={{ marginBottom: 15 }}>
        <Grid item xs={5}>
          <Autocomplete
            id="center"
            onChange={(event, newValue) => {
              if (newValue) {
                let obj = JSON.parse(JSON.stringify(newValue, null, " "));
                setCentreIdFilt(obj.id);
              }
            }}
            freeSolo
            blurOnSelect
            options={centerInfo?.results}
            disableCloseOnSelect
            getOptionLabel={(option: any) =>
              (option?.display_name === null
                ? option?.name
                : option?.display_name) +
              "(" +
              option?.center_code +
              ")"
            }
            onInputChange={(event, newInputValue) => {
              getCenterInfo(`?name_or_code=${newInputValue}`);
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Hospital/Doctor"
                variant="outlined"
                fullWidth
                required
              />
            )}
          />
        </Grid>
        <Grid item xs={1}>
          <FormControl component="fieldset">
            <FormGroup aria-label="position" row>
              <FormControlLabel
                control={
                  <Checkbox
                    color="primary"
                    checked={isActiveFilt}
                    onClick={() => {
                      setIsActiveFilt(!isActiveFilt);
                    }}
                  />
                }
                label="Is Active"
                labelPlacement="end"
              />
            </FormGroup>
          </FormControl>
        </Grid>
        <Grid item xs={3}>
          <Button
            variant="contained"
            color="primary"
            size="large"
            fullWidth
            onClick={handleFilter}
            style={{ height: 54 }}
          >
            Filter
          </Button>
        </Grid>
        <Grid item xs={3}>
          <Button
            variant="contained"
            color="secondary"
            size="large"
            fullWidth
            style={{ height: 54 }}
            onClick={() =>
              history.push("/dashboard/gnadmin/promotional_campaign")
            }
          >
            Reset
          </Button>
        </Grid>
      </Grid>
      <div>
        <PromotionalCamp centre={centreIdProp} isActive={isActiveProp} />
      </div>
    </div>
  );
};

const mapStateToProps = (state: any) => ({
  centerInfo: state.GenomicsAdminReducer.centerInfo,

  packageList: state.GenomicsAdminReducer.packageList,
});

export default connect(mapStateToProps, {
  getCenterInfo,
  createPromoCamp,
  getPackage,
})(PromotionalCampMaster);
